import { TOUCH_QUERY } from '~/lib/hooks/useMediaQuery';

/**
 * The composer textarea's max height. On phones/tablets it's capped to ~35% of
 * the visible viewport, so a long prompt can't push the thread and the Send
 * button under the on-screen keyboard. Desktop keeps the fixed cap.
 */
export function composerMaxHeight(max: number): number {
  if (typeof window === 'undefined' || !window.matchMedia(TOUCH_QUERY).matches) {
    return max;
  }

  const visible = window.visualViewport?.height ?? window.innerHeight;

  return Math.max(96, Math.min(max, Math.round(visible * 0.35)));
}
